import { gql } from 'apollo-boost';

export const GET_VIEWABILITY = gql`
query reportViewabilityByPublisher($publishers: [String!]) {
    reportViewabilityByPublisher(publishers:$publishers) {
      yesterdayViewability
      todayViewability
      sevenDaysViewability
      monthViewability
      sevenDaysByDaysViewability
      {
        date
        value
      }
    }
}
`;

export const GET_CPM = gql`
query reportCPMByPublisher($publishers: [String!]) {
    reportCPMByPublisher(publishers:$publishers) {
      yesterdayCPM
      todayCPM
      sevenDaysCPM
      monthCPM
      sevenDaysByDaysCPM
      {
        date
        value
      }
    }
}
`;

export const GET_IMPRESSIONS = gql`
query reportImpressionsByPublisher($publishers: [String!]) {
  reportImpressionsByPublisher(publishers:$publishers) {
    yesterdayImpressions
    todayImpressions
    sevenDaysImpressions
    monthImpressions
    sevenDaysByDaysImpressions
    {
      date
      value
    }
  }
}
`;

export const GET_REVENUE = gql`
query reportRevenueByPublisher($publishers: [String!]) {
  reportRevenueByPublisher(publishers:$publishers) {
    yesterdayRevenue
    todayRevenue
    sevenDaysRevenue
    monthRevenue
    sevenDaysByDaysRevenue
    {
      date
      value
    }
  }
}
`;



export const GET_ADUNITS = gql`
query adUnitIndicatorsByPublisherId($publishers: [String!]) {
  adUnitIndicatorsBypublishers(publishers:$publishers)
  {
    name
    impressions
    clicks
    cpm
    viewability
    sizes {
      size
    }
  }
}
`;
